import { SubscriptionAnalyseModal } from '../../../../styledComponents/Modals/SubscriptionAnalyseModal/SubscriptionAnalyseModal';
import { useSREditSubscriptionAnalyseModal } from './srEditSubscriptionAnalyseModal.hooks';

type SRSubscriptionAnalyseModalProps = {
  onAnalyseSuccess?: () => void;
};

const SRSubscriptionAnalyseModal = ({
  onAnalyseSuccess,
}: SRSubscriptionAnalyseModalProps) => {
  const {
    isSubscriptionAnalyseLoading,
    isSubscriptionMembershipInProgress,
    handleSubmit,
    initialValues,
    handleCancel,
    totalMemberships,
  } = useSREditSubscriptionAnalyseModal(onAnalyseSuccess);
  return (
    <SubscriptionAnalyseModal
      isSubscriptionAnalyseLoading={isSubscriptionAnalyseLoading}
      isSubscriptionMembershipInProgress={isSubscriptionMembershipInProgress}
      handleCancel={handleCancel}
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      totalMemberships={totalMemberships}
    />
  );
};

export default SRSubscriptionAnalyseModal;
